import { RankingApiHospitalItem, RankingHospitalItem } from "@/entities/search-ranking/model/types"

export const mapRankingApiToItem = (item: RankingApiHospitalItem): RankingHospitalItem => ({
  hospitalOriginId: item.hospitalOriginId,
  rank: item.currentRank,
  previousRank: item.previousRank,
  name: item.hospitalName,
  address: item.jibunAddress ?? item.address,
  score: item.hospitalRating,
  reviewCount: item.hospitalReviewCount,
  imageUrl: item.mainImage?.s3Url,
})
